'use client';

import React, { useState } from 'react';

interface AccordionItemProps {
  question: string;
  answer: string;
}

const AccordionItem: React.FC<AccordionItemProps> = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="bg-[#f5f3f7] rounded-2xl overflow-hidden transition-all duration-300">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex items-center justify-between p-6 sm:p-8 text-left hover:bg-[#ede9f1] transition-colors duration-200"
        aria-expanded={isOpen}
      >
        <h3 className="text-[18px] sm:text-[20px] font-bebas font-normal text-[#3f1651] uppercase pr-4">
          {question}
        </h3>
        <svg
          className={`w-6 h-6 flex-shrink-0 text-[#8923b3] transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>
      <div
        className={`overflow-hidden transition-all duration-300 ease-in-out ${
          isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <p className="text-[14px] sm:text-[15px] font-poppins font-normal text-[#666666] leading-[1.6] px-6 sm:px-8 pb-6 sm:pb-8">
          {answer}
        </p>
      </div>
    </div>
  );
};

export default AccordionItem;